import React from 'react';

const FooterNew: React.FC = () => {
  return (
    <footer className="bg-friet-beige border-t border-friet-red/15">
      <div className="py-8 md:py-10">
        <div className="container mx-auto px-8">
          <div className="flex flex-col md:flex-row items-center md:items-center justify-between gap-8 md:gap-8">

            <div className="flex flex-col items-center md:items-start gap-2">
              <img src="/images/logonav.png" alt="FrietPlus Logo" className="h-24 md:h-28 object-contain" />
              <p className="font-script text-lg italic" style={{ color: '#C4282D' }}>Net dat beetje extra</p>
            </div>

            <div className="flex flex-col items-center md:items-end gap-3">
              <h4 className="font-bold text-friet-black text-xs uppercase tracking-[0.2em]">Contact</h4>
              <div className="flex flex-col items-center md:items-end gap-2 text-sm font-serif text-friet-oak/70">
                <a href="tel:+32478758023" className="flex items-center gap-3 hover:text-friet-red transition-colors group">
                  <i className="fas fa-phone text-friet-red/60 group-hover:text-friet-red text-xs transition-colors"></i>
                  0478 / 75.80.23
                </a>
                <a href="mailto:info@frietplus.com" className="flex items-center gap-3 hover:text-friet-red transition-colors group">
                  <i className="fas fa-envelope text-friet-red/60 group-hover:text-friet-red text-xs transition-colors"></i>
                  info@frietplus.com
                </a>
                <p className="flex items-center gap-3 text-friet-oak/50">
                  <i className="fas fa-map-marker-alt text-friet-red/60 text-xs"></i>
                  Dworp, Vlaams-Brabant
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className="border-t border-friet-red/15 py-4">
        <div className="container mx-auto px-8 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-friet-oak/40 font-serif">
          <span>© {new Date().getFullYear()} FrietPlus. Alle rechten voorbehouden.</span>
          <span>Dworp, België</span>
        </div>
      </div>
    </footer>
  );
};

export default FooterNew;
